import type { SubscriptionResponse, SubscriptionStatus, SubscriptionDisplayStatus } from '../../api/models/bff/Subscription';
import type { Cancellation, CancellationEligibility, CancellationStatus, CancellationType } from '../../api/models/bff/Cancellation';
import { generateId, generateDate } from '../utils/generators';
import type { Price } from '../../api/models/bff/Price';

export function createMockPrice(overrides?: Partial<Price>): Price {
  return {
    amount: '100.00',
    currency: 'EUR',
    ...overrides,
  };
}

export function createMockSubscription(overrides?: Partial<SubscriptionResponse>): SubscriptionResponse {
  const id = generateId('sub');
  const status: SubscriptionStatus = 'ACTIVE';
  const displayStatus: SubscriptionDisplayStatus = 'ACTIVE';
  const cancellationEligibility: CancellationEligibility[] = ['IMMEDIATE', 'END_OF_COMMITMENT'];

  return {
    id,
    status,
    displayStatus,
    plan: {
      code: 'standard-plan',
    },
    cancellationEligibility,
    price: createMockPrice(),
    effectivePrice: { gross: createMockPrice(), net: createMockPrice() },
    effectivePriceSchedule: [],
    ...overrides,
  };
}

export function createMockCancellation(overrides?: Partial<Cancellation>): Cancellation {
  const id = generateId('cancel');
  const status: CancellationStatus = 'PENDING';
  const type: CancellationType = 'IMMEDIATE';
  const oneYearFromNow = new Date();
  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
  const MILLISECONDS_IN_A_MINUTE = 60000;
  const minutesOffset = (oneYearFromNow.getTime() - Date.now()) / MILLISECONDS_IN_A_MINUTE;
  const effectiveDate = generateDate(minutesOffset);

  return {
    id,
    status,
    type,
    effectiveDate,
    ...overrides,
  };
}
